import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Axios from '../../../axios/axios';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Spinner from '../../Loader/Spinner';
import { useNavigate } from "react-router-dom";

const Catalogue = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const settings = {
    rows: 2,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    autoplay: true,              
    autoplaySpeed: 2000,          // ⏱️  Time in milliseconds between scrolls (2 seconds)
    pauseOnHover: true,           // 🖱️ Pause autoplay when mouse hovers over
    nextArrow: (
      <div className="slick-arrow slick-next">
        <button className="btn btn-primary">
          <span className="fa fa-chevron-right"></span>
        </button>
      </div>
    ),
    prevArrow: (
      <div className="slick-arrow slick-prev">
        <button className="btn btn-primary">
          <span className="fa fa-chevron-left"></span>
        </button>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 680,
        settings: {
          rows: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          rows: 1,
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const fetchBrands = async () => {
      setLoading(true)
      try {
        const response = await Axios.get('/type/spare');
        setBrands(response.data);
        setLoading(false)
      } catch (error) {
        console.error('Error fetching brands:', error);
      }
    };
    fetchBrands();
  }, []);

  return (
    <div
      className="Catalogue-container"
      style={{ marginTop: '-2%' }}
    >
      <div className="">
        {/* Search by Catalogue */}
        <section  > 
          <h2 className="text-center mt-5 Layout-Title">SEARCH BY BRAND</h2>
          <Slider {...settings}>
            {brands.map((brand) => (
              <div className="slide-item" key={brand._id}>
                <div
                  className="slider-div text-center"
                  onClick={() => {
                    navigate(`/category?brandId=${brand._id}`, {
                      state: {
                        spareBrand: brands,
                      },
                    });
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={brand.images[0] || '/images/default.png'}
                    className="img-fluid w-50"
                    alt={brand.name}
                    style={{ objectFit: 'contain', height: '101px', width: '179px' }}
                  />
                  <p>{brand.name}</p>
                </div>
              </div>
            ))}


            {loading && <Spinner />}
          </Slider>
        </section>
      </div>
    </div>
  );
};

export default Catalogue;
